module.exports = __webpack_public_path__ + "img/payment_pages.d642d64c.svg";